import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import {
  ServicePartnerCollection,
  ServicePartnerCollectionFormData,
} from "@rumble-it/common-lib/types/models/ServicePartnerCollection.interface";
import { axiosInstance } from "../client";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@/lib/constants/mimeTypes";

export interface ServicePartnerCollectionQueryParams extends PaginationParams {}

export const fetchServicePartnerCollections = async (
  params: ServicePartnerCollectionQueryParams,
): Promise<CollectionResponse<ServicePartnerCollection>> =>
  axiosInstance
    .get("/admin/service-partners/collections", { params })
    .then((response) => response.data);

export const createServicePartnerCollection = async (
  data: ServicePartnerCollectionFormData,
): Promise<ServicePartnerCollection> =>
  axiosInstance
    .post("/admin/service-partners/collections", data)
    .then((response) => response.data);

export const fetchServicePartnerCollectionById = async (
  id: string,
): Promise<ServicePartnerCollection> =>
  axiosInstance
    .get(`/admin/service-partners/collections/${id}`)
    .then((response) => response.data);

export const updateServicePartnerCollectionById = async (
  id: string,
  data: Partial<ServicePartnerCollectionFormData>,
): Promise<ServicePartnerCollection> =>
  axiosInstance
    .patch(`/admin/service-partners/collections/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteServicePartnerCollectionById = async (
  id: string,
): Promise<null> =>
  axiosInstance
    .delete(`/admin/service-partners/collections/${id}`)
    .then((response) => response.data);
